import { type ReactNode } from "react";
import { type BaseNotificationData, type NotificationContext, type NotificationDefinition } from "./index";
import { type NotificationType } from "./NotificationType";

export interface NotificationRegistry {
  renderTitle: <T extends BaseNotificationData>(data: T, context: NotificationContext) => ReactNode;
  renderTitleGA: <T extends BaseNotificationData>(data: T, context: NotificationContext) => ReactNode;
  renderDescription: <T extends BaseNotificationData>(data: T, context: NotificationContext) => ReactNode;
}

export class NotificationRegistryImpl implements NotificationRegistry {
  private data: Dict<NotificationDefinition<any>> = {};

  addNotificationDefinition(definition: NotificationDefinition<any>) {
    this.data[definition.type] = definition;
  }

  private getNotificationDefinition(type: NotificationType) {
    return this.data[type];
  }

  renderTitle<T extends BaseNotificationData>(data: T, context: NotificationContext) {
    return this.getNotificationDefinition(data.subTypeCode).renderTitle(data, context);
  }

  renderTitleGA<T extends BaseNotificationData>(data: T, context: NotificationContext) {
    return this.getNotificationDefinition(data.subTypeCode).renderTitleGA(data, context);
  }

  renderDescription<T extends BaseNotificationData>(data: T, context: NotificationContext) {
    return this.getNotificationDefinition(data.subTypeCode).renderContents(data, context);
  }
}
